import { render, staticRenderFns } from "./RemoveProductsSelectionModal.vue?vue&type=template&id=af1386d0&scoped=true"
import script from "./RemoveProductsSelectionModal.vue?vue&type=script&lang=js"
export * from "./RemoveProductsSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveProductsSelectionModal.vue?vue&type=style&index=0&id=af1386d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1386d0",
  null
  
)

export default component.exports